import React, { useEffect, useState } from "react";
import LazyLoad from "react-lazyload";
import Modal from 'react-modal';
import { Link } from "react-router-dom";

import all from "../../../../assets/ear.png";

const Craft = ({ posts }) => {

    const [modalIsOpen, setIsOpen] = React.useState(false);

    function openModal() {
      setIsOpen(true);
    }
  
    function afterOpenModal() {
      // references are now sync'd and can be accessed.
      // document.getElementById("body").style.opacity = "0.1";
      document.getElementById("modal-content2").classList.add("modal-fade-in");
    }
  
    function closeModal() {
      setIsOpen(false);
    }
  
  
  
  
  
    return  (
        <div className="third-section">

        <div className="nextship">
          <div className="ship-left">
            <p className="txt-head">The Golden Shamrock Prize</p>
            <h1 className="handbag-title" style={{fontFamily:"The new Elegance"}}>A Beautiful Pair of Silver Earrings Handmade in The Dingle Peninsula
</h1>
            <div className="ship-right mobile-ship">
          <LazyLoad height={200}>
            <img src={all} className="txt-img" />
            </LazyLoad>
          </div>
            <p className="txt-paragraph">This Golden Shamrock Prize is worth over $240 USD: a most beautiful pair of silver earrings with the Celtic spiral of life motif and a beautiful 6mm lolite stone, handmade by the most talented goldsmith: Niamh Utch. She has retired but makes some special pieces once in a while, and I have managed to buy a few for the next few months to gift to lucky members.<br/>
Keep your eye out for the draw!<br/>
We will choose the winner of these beauties on the 1st of May. As always, you need to be an active member of MyIrelandBox, receiving them to your door at the date of the draw. The Golden Shamrock prize for March was a beautiful, green topaz pendant and we have chosen winner and I’ve reached out to her. She’s going to be so excited when she learns that it is she who won this most beautiful prize.</p>
             <div className="handbag-display">
             <Link to={window.location.href.includes("christmas-ecard") ? "/gifting-form" :"/form"}  >{window.location.href.includes("christmas-ecard") ? "Gift to Enter Draw" :"Join to Enter Draw"} </Link>
             <p onClick={openModal} className="hoverable">See Rules</p>
             </div>
          </div>
          <div className="ship-right desktop-ship">
          <LazyLoad height={200}>
            <img src={all} className="txt-img" />
            </LazyLoad>
          </div>

          <div className="thebade" onClick={openModal} >
        <LazyLoad height={200}>
             <img src={posts.acf.modalBadge} id="badge-btn-image" alt="badgeimage"></img>
        </LazyLoad>
      </div>
        </div>

            
      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        id="modal-content2"
        contentLabel="Example Modal"
      >
      <div className="draw-offer-homepage" >
        <div onClick={closeModal} id="closemodal-badge2">X</div>
            <LazyLoad height={200}>
        <img id="badge3" src={posts.acf.modalBadge} alt="badgeimage
        "></img>
        </LazyLoad>
          <p   dangerouslySetInnerHTML={{
            __html: posts.acf.modalcontent2,
          }}></p>
          <Link to="/form">
        <button className="modalbtn " onClick={closeModal}>
          Continue to Enter
        </button>
        </Link>
        </div>
      </Modal>

     </div>
    )
}

export default Craft;